exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".levelSeeAll__seeAllContainer___10sXc {\n  text-align: left;\n  padding-top: 24px;\n  margin-bottom: -5px;\n  border-top: 1px solid #e6e6e6; }\n  .levelSeeAll__seeAllContainer___10sXc > span {\n    font-size: 15px;\n    font-weight: 600;\n    line-height: 23px;\n    margin-right: 8px;\n    color: #000000; }\n  .levelSeeAll__seeAllContainer___10sXc > i {\n    color: #f94144;\n    font-size: 15px;\n    font-weight: 800; }\n", ""]);

// exports
exports.locals = {
	"seeAllContainer": "levelSeeAll__seeAllContainer___10sXc"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/ModulePage/LevelSeeAll/levelSeeAll.scss
// module id = 4718
// module chunks = 6